import React, { useState } from 'react'
import "./test.scss"

const Test = () => {

  const [range, setRange] = useState(0)
  const [rangeval, setRangeVal] = useState(0)

  const handleRange = (e) => {
    setRangeVal(range)
    if (range >= 50) {
      console.log(`Range is above 50..! that is: ${range}`);
    }
  }

  return (
    <div className='w-50' style={{ margin: "auto" }}>
      <label for="customRange1" class="form-label text-primary mt-5 mb-5">Example range</label>
      <input
        type="range"
        class="form-range"
        id="customRange1"
        onChange={(e) => {
          setRange(e.target.value)
        }}
      />
      <button
        onClick={handleRange}
        class="mt-3"
        style={{
          border: "1px solid #0c6dfd",
          background: "#0c6dfd",
          color: "#FFF",
          padding: "10px 10px",
          borderRadius: "8px"
        }}
      >Your Range</button>
      <div
        className='mt-5 text-primary'
        style={{
          border: "1px solid #0c6dfd",
          width: "40px",
          height: "40px",
          margin: "auto",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "bold"
        }}
      >{rangeval}</div>
    </div>
  )
}

export default Test
